import { WorkingHourInterval } from "@/domain/entities/WorkingHourInterval";
import { WEEKDAY_LABELS, WEEKDAY_ORDER } from "../constants/weekdayLabels";
import { WorkingHourDayViewModel } from "../viewmodels/WorkingHourDayViewModel";

// Agrupa a lista flat de intervalos por dia da semana — mesma ideia do
// buildSchedule do app do profissional (diag-reactnative), mas só leitura
// (o admin aqui só visualiza, não edita a grade).
const toListViewModel = (intervals: WorkingHourInterval[]): WorkingHourDayViewModel[] => {
    return WEEKDAY_ORDER.map((weekday) => {
        const dayIntervals = intervals
            .filter((interval) => interval.weekday === weekday)
            .sort((a, b) => a.start_time.localeCompare(b.start_time));

        return {
            weekday,
            label: WEEKDAY_LABELS[weekday],
            enabled: dayIntervals.length > 0,
            intervals: dayIntervals,
            formattedIntervals: dayIntervals.length
                ? dayIntervals.map((interval) => `${interval.start_time} - ${interval.end_time}`).join(", ")
                : "Fechado",
        };
    });
};

export default { toListViewModel };
